<template>
	<div class="home">
		<vue-headful
			:title="$t('pageTitle')"
			:description="$t('pageMetaDescription')"
		/>
		<v-img
			class="rounded"
			style="max-height: 90vh"
			:aspect-ratio="$vuetify.breakpoint.xsOnly ? 10/12: null"

			:src="'https://sgpphoto.blob.core.windows.net/sgpweb/SgpHome-min.png'"
		>
			<v-container fluid class="fill-height">
				<v-row class="fill-height">
					<v-col cols="10" md="8" lg="6" xl="4" class="pa-8 fill-height ">
						<div class="d-flex flex-column  fill-height">
						<v-img class="flex-grow-0" src="https://sgpphoto.blob.core.windows.net/sgpweb/sgpHomeTextUp-min.png"/>
						<div class="flex-grow-1"></div>
						<v-img class="flex-grow-0" src="https://sgpphoto.blob.core.windows.net/sgpweb/sgpHomeTextDown-min.png"/>
						</div>
					</v-col>
				</v-row>
			</v-container>

		</v-img>

	</div>
</template>
<style lang="scss">
.home{
	h1{
		font-size: 4rem;
	}

	.subheader{
	font-size: 1.5rem;
	}

}

</style>

<script>
import { mapGetters } from "vuex";
export default {
	name: "Home",
	components: {
	},
	data() {
		return {
			currentEvent: null,
		};
	},

	computed: {
		...mapGetters(["SasToken"]),
	},
	async mounted() {},
	methods: {
		changeVal(val) {
			this.$log.debug("change: " + val);
		},
	},
};
</script>
<i18n>
{
	"it":{
		"pageTitle": "SGPix by Stefano Guindani Photo",
		"pageMetaDescription": "Acquista le foto degli eventi"
	}
}
</i18n>
